import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { UnidadFuncionalService } from '../../../../../src/app/shared/services';
import { ImportUnidadFuncionalExcelRequestDto } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-dialog-unidad-funcional-import',
  templateUrl: './dialog-unidad-funcional-import.component.html',
  styleUrls: ['./dialog-unidad-funcional-import.component.scss']
})

export class DialogUnidadFuncionalImportComponent implements OnInit {

  isImporting: boolean = false;
  isExporting: boolean = false;

  fileBase64: string | ArrayBuffer | null;
  fileName: string = "";

  constructor(
    private dialogRef: MatDialogRef<DialogUnidadFuncionalImportComponent>,
    @Inject(MAT_DIALOG_DATA) public input: DialogUnidadFuncionalImportComponent,
    private sharedFunctions: SharedFunctions,
    private service: UnidadFuncionalService
  ) {
    // this.uploadObj.appendTo('#defaultupload');
  }

  ngOnInit(): void {
  }

  isProcessing() {
    return (this.isImporting || this.isExporting);
  }

  convertFileToBase64(event) {
    this.fileBase64 = null;
    this.fileName = '';

    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {
        // var fileExtension = (file?.name?.split('.')?.pop() ?? "");
        // if (fileExtension == null || fileExtension?.toLowerCase() != "csv") {
        //   this.sharedFunctions.showMessage("Solo puede adjuntar archivos CSV", "Error");
        // }

        this.fileBase64 = reader.result;
        this.fileName = file?.name;
        // console.log(reader.result);
      };
    }
  }

  onImportar() {
    var r = new ImportUnidadFuncionalExcelRequestDto(this.fileName, this.fileBase64);

    this.isImporting = true;
    this.service.importFromExcel(r).subscribe(data => {
      this.isImporting = false;
      if (data != null && data.Success && data.Result != null) {
        var messErr = data.Result.Observaciones != null && data.Result.Observaciones != "" ? "Observaciones: " + "<br>" + data.Result.Observaciones : "";
        this.sharedFunctions.showMessage("Se importaron y agregaron "+ data.Result.Count + " de un total de "+  data.Result.Items.length + "." +
          "<br>" + messErr, "Importación de Archivo");
      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error realizando la importación", "Importación de Archivo");
    },
    (err: HttpErrorResponse) => {
      this.isImporting = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  onDownloadImportTemplate() {
    this.isExporting = true;
    this.service.downloadImportUfsTemplate().subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Template_Importacion_UFs.xlsx";
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
